var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.newYear)?_c('back-new-year',{attrs:{"height":_vm.height}}):_c('v-sheet',{staticClass:"back",style:({height:_vm.height+'px'}),attrs:{"color":_vm.$mainColor}},[_c('div',{staticClass:"background"},_vm._l((10),function(i){return _c('span',{key:i,staticClass:"rain"})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }